/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Notfound_Message1Inputs */

const id_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman yang Anda cari tidak ada.`)
};

const ms_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman yang anda cari tidak wujud.`)
};

const da_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden du leder efter findes ikke.`)
};

const de_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die von Ihnen gesuchte Seite existiert nicht.`)
};

const en_us2_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

const es_es2_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La página que buscas no existe.`)
};

const es_mx2_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La página que buscas no existe.`)
};

const fil_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pahinang iyong hinahanap ay hindi umiiral.`)
};

const fr_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La page que vous recherchez n'existe pas.`)
};

const it_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pagina che stai cercando non esiste.`)
};

const hu_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A keresett oldal nem létezik.`)
};

const nl_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De pagina die je zoekt bestaat niet.`)
};

const no_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden du leter etter finnes ikke.`)
};

const pl_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona, której szukasz, nie istnieje.`)
};

const pt_br2_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

const pt_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A página que procura não existe.`)
};

const ro_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina pe care o cauți nu există.`)
};

const fi_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etsimääsi sivua ei ole olemassa.`)
};

const sv_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidan du letar efter finns inte.`)
};

const vi_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang bạn đang tìm kiếm không tồn tại.`)
};

const tr_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aradığınız sayfa mevcut değil.`)
};

const cs_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka, kterou hledáte, neexistuje.`)
};

const bg_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страницата, която търсите, не съществува.`)
};

const ru_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница, которую вы ищете, не существует.`)
};

const uk_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторінка, яку ви шукаєте, не існує.`)
};

const ar_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة التي تبحث عنها غير موجودة.`)
};

const hi_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेज मौजूद नहीं है।`)
};

const th_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าที่คุณกำลังมองหาไม่มีอยู่`)
};

const ja_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お探しのページは存在しません。`)
};

const zh_cn2_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

const zh_hant1_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

const ko_components_notfound_message1 = /** @type {(inputs: Components_Notfound_Message1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

/**
* | output |
* | --- |
* | "The page you are looking for does not exist." |
*
* @param {Components_Notfound_Message1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_notfound_message1 = /** @type {((inputs?: Components_Notfound_Message1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Notfound_Message1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_notfound_message1(inputs)
	if (locale === "ms") return ms_components_notfound_message1(inputs)
	if (locale === "da") return da_components_notfound_message1(inputs)
	if (locale === "de") return de_components_notfound_message1(inputs)
	if (locale === "en-US") return en_us2_components_notfound_message1(inputs)
	if (locale === "es-ES") return es_es2_components_notfound_message1(inputs)
	if (locale === "es-MX") return es_mx2_components_notfound_message1(inputs)
	if (locale === "fil") return fil_components_notfound_message1(inputs)
	if (locale === "fr") return fr_components_notfound_message1(inputs)
	if (locale === "it") return it_components_notfound_message1(inputs)
	if (locale === "hu") return hu_components_notfound_message1(inputs)
	if (locale === "nl") return nl_components_notfound_message1(inputs)
	if (locale === "no") return no_components_notfound_message1(inputs)
	if (locale === "pl") return pl_components_notfound_message1(inputs)
	if (locale === "pt-BR") return pt_br2_components_notfound_message1(inputs)
	if (locale === "pt") return pt_components_notfound_message1(inputs)
	if (locale === "ro") return ro_components_notfound_message1(inputs)
	if (locale === "fi") return fi_components_notfound_message1(inputs)
	if (locale === "sv") return sv_components_notfound_message1(inputs)
	if (locale === "vi") return vi_components_notfound_message1(inputs)
	if (locale === "tr") return tr_components_notfound_message1(inputs)
	if (locale === "cs") return cs_components_notfound_message1(inputs)
	if (locale === "bg") return bg_components_notfound_message1(inputs)
	if (locale === "ru") return ru_components_notfound_message1(inputs)
	if (locale === "uk") return uk_components_notfound_message1(inputs)
	if (locale === "ar") return ar_components_notfound_message1(inputs)
	if (locale === "hi") return hi_components_notfound_message1(inputs)
	if (locale === "th") return th_components_notfound_message1(inputs)
	if (locale === "ja") return ja_components_notfound_message1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_notfound_message1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_notfound_message1(inputs)
	return ko_components_notfound_message1(inputs)
});
export { components_notfound_message1 as "components.notFound.message" }